export default __webpack_public_path__ + "static/media/Cluster-Icon-White.4706747c.svg";